import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';
import { addComment, addCommentReply } from 'project/ducks/revisions';
import EntryCommentForm from 'project/components/entry_details/entry_comment_form';

const validate = (values) => {
  if (!values.comment || !values.comment.trim()) {
    return { comment: 'Please add some text.' };
  }
}
const WrappedEntryCommentForm = reduxForm({ form: 'entry-comment-form', validate })(EntryCommentForm);

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  addComment,
  addCommentReply,
})(WrappedEntryCommentForm);



// WEBPACK FOOTER //
// ./project/containers/entry_comment_form.jsx